import Dashboard from './components/dashboard';

function App() {
  return (
    <>
      <Dashboard></Dashboard>
    </>
  );
}

export default App;
